import { createElement } from 'react';
import dayjs from 'dayjs';

export const DEFAULT_DATE = '0001-01-01T00:00:00';

export function dateFormat(date: string | undefined, format = '') {
  if (date && date !== undefined && format && format !== '')
    return dayjs(date).format(format);
  return dayjs(date).format('MM/DD/YYYY h:mm A');
}

export const getPastDate = (days: number) => {
  return new Date(new Date().setDate(new Date().getDate() - days));
};

// checks whether a given value is empty
// if yes returns true, else false
export function isEmpty(value: any): boolean {
  if (!value || value === null || value === undefined) return true;
  if (typeof value === 'string') {
    if (value?.trim() === '') return true;
  }
  if (typeof value === 'object') {
    if (!Object.keys(value) || Object.keys(value)?.length === 0) return true;
    if (Object.keys(value)?.length === 1 && Object.keys(value)?.includes('')) {
      return true;
    }
  }
  return false;
}

export function isValidDate(date?: string): boolean {
  if (date && !isEmpty(date) && date !== DEFAULT_DATE && date !== '01/01/1')
    return true;
  return false;
}

export function scrollTop() {
  window?.scrollTo(0, 0);
}

export function getLayoutSpec(type: string): any {
  if (type === 'leftnav') return 64;
  if (type === 'header') return 52;
}

// return the screen's resolution height
export function getResolutionHeight(): number {
  const resHeight = window?.screen?.availHeight;
  if (resHeight) return resHeight;
  return 0;
}

export function hasLayoutSpecs(type: string): boolean {
  const header = document.querySelector('[data-testid="home_component_box"]');
  const nav = document.querySelector('[role="menu"]');
  if (!nav) return false;
  if (type === 'layout' && nav && header) {
    return true;
  }
  if (type === 'leftnav' && nav) {
    return true;
  }
  if (type === 'header' && header) {
    return true;
  }
  return false;
}

export function getCleanValue(value: string): string {
  if (!value || value === null || value === undefined || value === '')
    return '-';
  return value;
}

// accepts a string and returns string in sentence case
export function toSentenceCase(value: string): string {
  if (value) {
    return `${value?.substring(0, 1)?.toUpperCase()}${value
      ?.substring(1)
      ?.toLowerCase()}`;
  }
  return '';
}

export type SearchDateRange = {
  endDate?: Date | null;
  startDate?: Date | null;
};

export type SearchOption = {
  label: JSX.Element;
  type: string;
  value: string;
};

export function GetSearchOptions(): SearchOption[] {
  const searchOptions = [
    {
      label: createElement('div', null, ['Date Range']),
      type: 'date',
      value: 'DATE_RANGE',
    },
  ];
  return searchOptions;
}

export const DateOptionToQueryParam: { [key: string]: string[] } = {
  DATE_RANGE: ['startDate', 'endDate'],
};
